import axios from "axios";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";
import Input from "~/components/Backroom/Input";
import ThreeColumn from "~/components/Backroom/layout/ThreeColumn";
import Button from "~/components/Button";
import { SectionHeading } from "~/components/SectionHeading";
import { Text } from "~/components/Text";
import { showToast } from "~/utils/toast";
import Image from "next/image";

type Inputs = {
  email: string;
};

const BackroomForgotPasswordPage = () => {
  const {
    register,
    formState: { errors, isDirty, isValid },
    handleSubmit,
  } = useForm<Inputs>({ mode: "onChange" });

  const router = useRouter();

  const onSubmit = async (data: Inputs) => {
    try {
      const result = await axios.put("/api/backroom/forgot-password", data);

      if (result.status === 200) {
        showToast("success", "Email sendt", "Tjek din email");
        return router.replace("/backroom/login");
      }

      throw new Error();
    } catch (error) {
      showToast("danger", "Noget gik galt", "Prøv igen senere.");
    }
  };

  return (
    <div className="-mx-5">
      <ThreeColumn
        className="mb-10"
        columnTwo={
          <section className="text-secondary-800">
            <SectionHeading>
              <SectionHeading.Title className="mb-7 sm:pt-36 text-black text-2xl sm:text-2xl">
                Glemt adgangskode
              </SectionHeading.Title>
              <Text className="mb-12">
                Du vil få tilsendt en email med et link til at nulstille din
                adgangskode.
              </Text>
            </SectionHeading>
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
              <Input
                register={register}
                label="Angiv din e-mail"
                placeholder="Email"
                className="mb-12"
                id="email"
                error={errors.email}
                registerOptions={{ required: "Dette felt er påkrævet" }}
              />

              <Button
                type="submit"
                variant="primary"
                size="lg"
                className="w-full"
                disabled={!isDirty || !isValid}
              >
                Send email
              </Button>
            </form>
          </section>
        }
        columnThree={
          <section className="">
            <Image
              src="/assets/images/login.png"
              alt="Din placering ved kortvisning uden fysisk butik"
              width={660}
              height={330}
              className=" rounded-lg"
            />
          </section>
        }
      />
    </div>
  );
};

export default BackroomForgotPasswordPage;
